var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.filteredSentence && _vm.hasParameter('sentence'))?_c('h4',{key:_vm.filteredSentence,staticClass:"exercise__filtered-sentence"},[_vm._v(_vm._s(_vm.filteredSentence))]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }